// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 833) return "bundle.e7b49e0b3d65694cff60.js";
	// return url for filenames based on template
	return "vendor." + "750d28d009897923caa7" + ".js";
};